import { render, staticRenderFns } from "./importTable.vue?vue&type=template&id=4dd7144f&scoped=true&"
import script from "./importTable.vue?vue&type=script&lang=js&"
export * from "./importTable.vue?vue&type=script&lang=js&"
import style0 from "./importTable.vue?vue&type=style&index=0&id=4dd7144f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd7144f",
  null
  
)

export default component.exports